/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DataAndType } from './DataAndType';
import {
    DataAndTypeFromJSON,
    DataAndTypeFromJSONTyped,
    DataAndTypeToJSON,
} from './DataAndType';

/**
 * 
 * @export
 * @interface CidDataResponse
 */
export interface CidDataResponse {
    /**
     * 
     * @type {DataAndType}
     * @memberof CidDataResponse
     */
    data?: DataAndType;
}

/**
 * Check if a given object implements the CidDataResponse interface.
 */
export function instanceOfCidDataResponse(value: object): value is CidDataResponse {
    let isInstance = true;

    return isInstance;
}

export function CidDataResponseFromJSON(json: any): CidDataResponse {
    return CidDataResponseFromJSONTyped(json, false);
}

export function CidDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CidDataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : DataAndTypeFromJSON(json['data']),
    };
}

export function CidDataResponseToJSON(value?: CidDataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': DataAndTypeToJSON(value.data),
    };
}

